export function getPreviousPage(context) {
  const { pageHistory } = context

  return pageHistory[pageHistory.length - 1]
}
